export default __webpack_public_path__ + "static/media/665.392b542d.jpg";